import React from "react";
import { Route, Routes } from "react-router-dom";
import { UberEatsCallback, UberEatsDetails, UbereatsList } from "./containers";
import { ProtectedRoute } from "../../shared";

export const Ubereats = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<UbereatsList />} />
        <Route path="/uber-eats-call-back" element={<UberEatsCallback />} />
        <Route element={<ProtectedRoute allowedRoute={["ubereats-view"]} />}>
          <Route path="/details/:id" element={<UberEatsDetails />} />
        </Route>
      </Routes>
    </>
  );
};
